import React, { useState, useEffect, useRef } from 'react'
import { 
    Layout,
    Col, 
    Row,
    Image,
    Button,
    Space,
    Table,
} from 'antd';
import Navbar from '../../Components/Navbar/Navbar';
import HeaderImage from '../../Assets/Images/CPM-HEADER-cropped-1.png'
import html2canvas from 'html2canvas';
import jsPDF from "jspdf";
import OwnerSignature from "../../Assets/Images/owner_signature.png"

import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { useReactToPrint } from "react-to-print";
import { SeeAttachment } from '../../Components/SeeAttachment';
import PreviewBillingSlip from '../../Components/PreviewBillingSlip';
import { 
    ProductOutlined,
} from '@ant-design/icons';
import { formatAmount, formatDate, refreshPage, extractDateTime } from '../../Utils/Common';
import LoadingModal from '../../Components/LoadingModal';
import { PreviewTable } from '../../Components/PreviewTable';

const PreviewOwnerIncome = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [billingData, setBillingData] = useState([])
    const [ownerData, setOwnerData] = useState([])
    const [expenseAttachment, setExpenseAttachment] = useState([]);
    const [paymentAttachment, setPaymentAttachment] = useState([]);

    const [billingDetails, setBillingDetails] = useState([])
    const [expenseDetails, setExpenseDetails] = useState([])
    const currentDateTime = new Date();
    // const currentDate = new Date().toISOString().split('T')[0];

    const { callPost, loading } = usePostRequest(()=>{
        refreshPage()
    });

    const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

    const handleSendEmail = async (ref) => {
        if (ref) {
            const element = document.getElementById(ref);
    
            html2canvas(element, { scale: 2,  useCORS: true  }).then(async (canvas) => {
                const scale = 0.7; // Set the desired scale (70%)
    
                // Create a new canvas with scaled dimensions
                const scaledCanvas = document.createElement('canvas');
                const context = scaledCanvas.getContext('2d');
                scaledCanvas.width = canvas.width * scale;
                scaledCanvas.height = canvas.height * scale;
    
                // Draw the original canvas onto the scaled canvas
                context.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, scaledCanvas.width, scaledCanvas.height);
    
                // Convert the scaled canvas to an image
                const imgData = scaledCanvas.toDataURL('image/jpeg', 1);
    
                const pdf = new jsPDF();
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const imgWidth = scaledCanvas.width;
                const imgHeight = scaledCanvas.height;
    
                // Calculate the ratio needed to fit the image within the PDF dimensions
                const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    
                // Calculate the new width and height of the image
                const newWidth = imgWidth * ratio;
                const newHeight = imgHeight * ratio;
    
                // Center the image in the PDF
                const imgX = (pdfWidth - newWidth) / 2;
                const imgY = 0;
    
                // Add the image to the PDF
                pdf.addImage(imgData, 'JPEG', imgX, imgY, newWidth, newHeight); // Use 'JPEG' format for better compression
                // pdf.save(`${billingData?.owner_name}_OwnerIncome_${extractDateTime(currentDateTime)}.pdf`);
    
                // Convert the pdf file from Blob to File obj (needed for upload API)
                const blobPdf = pdf.output('blob');
                const formPdf = new File([blobPdf], `${billingData?.owner_name}_OwnerIncome_${extractDateTime(currentDateTime)}.pdf`, {
                    type: blobPdf.type,
                });

                let expense_file = [];
                let payment_file = [];
                
                if(expenseAttachment){
                    expense_file = expenseAttachment.map((data) => {
                        return data?.file_url
                    });
                }

                if(paymentAttachment){
                    payment_file = paymentAttachment.map((data) => {
                        return data?.file_url
                    });
                }

                let binaryData = []; // Array to hold the generated PDF files

                // Use a map to handle the asynchronous operations
                const pdfPromises = bulkPrintRefs.current.map((ref, index) => {
                    const element = ref;

                    return html2canvas(element, { scale: 2,  useCORS: true  }).then(async (canvas) => {
                        const scale = 0.7; // Set the desired scale (70%)

                        // Create a new canvas with scaled dimensions
                        const scaledCanvas = document.createElement('canvas');
                        const context = scaledCanvas.getContext('2d');
                        scaledCanvas.width = canvas.width * scale;
                        scaledCanvas.height = canvas.height * scale;

                        // Draw the original canvas onto the scaled canvas
                        context.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, scaledCanvas.width, scaledCanvas.height);

                        // Convert the scaled canvas to an image
                        const imgData = scaledCanvas.toDataURL('image/jpeg', 1);

                        const pdf = new jsPDF();
                        const pdfWidth = pdf.internal.pageSize.getWidth();
                        const pdfHeight = pdf.internal.pageSize.getHeight();
                        const imgWidth = scaledCanvas.width;
                        const imgHeight = scaledCanvas.height;

                        // Calculate the ratio needed to fit the image within the PDF dimensions
                        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

                        // Calculate the new width and height of the image
                        const newWidth = imgWidth * ratio;
                        const newHeight = imgHeight * ratio;

                        // Center the image in the PDF
                        const imgX = (pdfWidth - newWidth) / 2;
                        const imgY = 0;

                        // Add the image to the PDF
                        pdf.addImage(imgData, 'JPEG', imgX, imgY, newWidth, newHeight);

                        // Convert the pdf file from Blob to File obj (needed for upload API)
                        const blobPdf = pdf.output('blob');
                        const formPdf2 = new File([blobPdf], `${billingData?.owner_name}_BillingSlip_${index}}.pdf`, {
                            type: blobPdf.type,
                        });

                        // Trigger download
                        // const link = document.createElement('a');
                        // link.href = URL.createObjectURL(blobPdf);
                        // link.download = `${billingData?.owner_name}_BillingSlip_${index}}.pdf`;
                        // link.click();

                        return formPdf2; // Return the formPdf2 file so we can push it later
                    });
                });

                // Use Promise.all to wait for all PDFs to be generated
                Promise.all(pdfPromises).then((formPdfs) => {
                    // All the PDFs are now in the `formPdfs` array
                    binaryData.push(...formPdfs); // Spread the result into the binaryData array
                    // Optionally, you can perform your file upload or other operations on binaryData here
                    const finalValues = Object.entries(
                        { 
                            owner_id: billingData.owner_id, 
                            rental_unit_id: billingData.rental_unit_id, 
                            attachment: formPdf, 
                            additional_attachments: [...expense_file, ...payment_file], 
                            additional_files: [...binaryData], 
                            filename: `${billingData?.owner_name}_OwnerIncome_${extractDateTime(currentDateTime)}.pdf` }).map(([key, value]) => ({
                        key,
                        value,
                    }));
                    callPost('emails/send_owner_income', finalValues, true);
                });
    
              
            });
        }
    };

    const columns = [
        {
            title: 'Billing Number',
            dataIndex: 'billing_id',
            key: 'billing_id',
            align: 'center'
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            align: 'center'
        },
        {
            title: 'Amount',
            dataIndex: 'amount_due',
            key: 'amount_due',
            align: 'right',
        },
    ];

    const columns2 = [
        {
            title: 'Billing Number',
            dataIndex: 'billing_id',
            key: 'billing_id',
            align: 'center'
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            align: 'center'
        },
        {
            title: 'Amount',
            dataIndex: 'amount_due',
            key: 'amount_due',
            align: 'right',
            render: (amount_due) => formatAmount(amount_due),
        },
    ];
    const columns3 = [
        {
          title: 'Date Added',
          dataIndex: 'added_on',
          key: 'added_on',
          width: '30%',
          render: (amount) => formatDate(amount),
        },
        {
          title: 'Attachments',
          dataIndex: 'link',
          key: 'link',
        },
    ]; 
    const columns4 = [
        {
          title: 'Date Added',
          dataIndex: 'added_on',
          key: 'added_on',
          width: '30%',
          render: (amount) => formatDate(amount),
        },
        {
          title: 'Link',
          render: (amount) => {
            const path = `/preview-billing/owner/${amount.billing_id}`;
            return (
                <span
                    // onClick={() => navigate(`/preview-billing/owner/${amount.billing_id}`)}
                    onClick={() => window.open(path, '_blank')}
                    style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                >
                    {amount.description}
                </span>
            );
        },
        },
    ]; 
    // 
    const componentRef = useRef();
    const bulkPrintRefs = useRef([]);
    // Function to serialize the HTML content of the div elements
    
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const handleBulkPrintRef = (ref) => {
        bulkPrintRefs.current.push(ref);
    };

    async function fetchBillingData  () {
        setIsLoading(true)
        const response = await UseGetRequest("payments/owner_income_breakdown", {billing_id: id});
        if (response?.data) {
            const billing = response?.data?.data?.billing_details?.map((data) => ({
                id: data.id,
                discount_item_id: data.discount_item_id,
                added_on: data.added_on,
                billing_id: data.billing_id,
                description: data.description,
                type: data.type,
                source_id: data.source_id,
                principal_amount: formatAmount(data.principal_amount),
                vat: formatAmount(data.vat),
                withholding_tax: formatAmount(data.withholding_tax),
                subtotal: formatAmount(data.subtotal),
                discount_amount: formatAmount(data.discount_amount),
                discount_vat: formatAmount(data.date_from),
                discount_wtax: formatAmount(data.discount_wtax),
                amount_due: formatAmount(data.amount_due),
                paid_amount: formatAmount(data.paid_amount),
            }))
            const allDetails = response?.data?.data?.owner_expenses?.flatMap((data) => data.details);

            let expense_attachment = response?.data?.data?.expense_attachments?.map((file) => ({
                ...file,
                link: (
                    <SeeAttachment
                    attachments={[
                        { file_url: file.file_url, file_name: file.file_name },
                    ]}
                    />
                ),
            })); 
            let payment_attachment = response?.data?.data?.payment_attachments?.map((file) => ({
                ...file,
                link: (
                    <SeeAttachment
                    attachments={[
                        { file_url: file.file_url, file_name: file.file_name },
                    ]}
                    />
                ),
            })); 
            setExpenseAttachment(expense_attachment)
            setPaymentAttachment(payment_attachment)
            setBillingData(response?.data?.data);
            fetchOwnerData(response?.data?.data?.owner_id)
            setBillingDetails(billing)
            setExpenseDetails(allDetails)
        } else {
          setBillingData([])
        }
        setIsLoading(false);
    };

    async function fetchOwnerData(owner_id) {
        // setIsLoading(true)
        const response = await UseGetRequest("owners/get", {owner_id: owner_id});
        if (response?.data) {
          
          setOwnerData(response?.data?.data[0]);
        } else {
          setOwnerData([])
        }
        // setIsLoading(false);
    };

    useEffect(() => {
        fetchBillingData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let uniqueIds = [];
    if(expenseDetails){
        uniqueIds = Array.from(new Set(expenseDetails?.map(item => item.billing_id)));
    }

    return (
        <Layout className='page'>
            <Navbar navKey={'property'}/>
            <Layout className='content-container content-container-print overflow-y'>
                <Row className='m-4 paper-view'>
                    <Col className='email-pad print-content' id="preview" ref={componentRef}>
                        <Row className='mb-5'>
                            <Col span={24} align="center">
                                <Image
                                    width={'auto'}
                                    height="100%"
                                    src={HeaderImage}
                                    alt="login-image"
                                    preview={false}
                                />
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={18} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Date :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {formatDate(billingData.added_on)}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={12} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Owner Name :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.owner_name}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={12} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Bldg & Unit No. :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.concatenated_property}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={12} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Address :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.address}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={12} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Period Covered :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.billing_date}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        {/* <Row className='mb-2'>
                            <Col span={18} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Contract Period :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.billing_date}
                                    </div>
                                </Space>
                            </Col>
                        </Row> */}
                        <Row className='center my-5'>
                            <Col className='divider-text'>
                                MONTHLY INCOME REPORT
                            </Col>
                        </Row>

                        <Row gutter={[16, 16]} className=''>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2 custom-table res-scroll'>
                                {/* <Table
                                    dataSource={billingDetails}
                                    columns={columns}
                                    rowKey="id"
                                    pagination={false}
                                /> */}
                                <PreviewTable
                                    dataSource={billingDetails}
                                    columns={columns}
                                />
                    
                            </Col>
                        </Row>

                        <Row gutter={[16, 16]} className='mb-2'>
                            <Col span={12}>
                            
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className=' amount-total-two' align='right'>
                                Total Income: {formatAmount(billingData.income_amount)}
                            </Col>
                        </Row>
                      
                        <Row gutter={[16, 16]} className='mb-2'>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="p-2 res-scroll custom-table">
                                {expenseDetails && (
                                    // <Table
                                    //     dataSource={expenseDetails}
                                    //     columns={columns2}
                                    //     rowKey="id"
                                    //     pagination={false}
                                    // />
                                    <PreviewTable
                                        dataSource={expenseDetails}
                                        columns={columns2}
                                    />
                                )}
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]} className='mb-2'>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} align='right' className='p-4 test-border'>
                                <Row className='mb-4'>
                                    <Col className='text-sm'>
                                        <strong>Owner Bank Details</strong>
                                    </Col>
                                </Row>
                                <Row className='ms-4'>
                                    <Space className='text-sm'>
                                        Account Name :
                                        <strong>{ownerData?.account_name}</strong>
                                    </Space>
                                </Row>
                                <Row className='ms-4'>
                                    <Space className='text-sm'>
                                         Bank Name :
                                        <strong>{ownerData?.bank_name}</strong>
                                    </Space>
                                </Row>
                                <Row className='ms-4'>
                                    <Space className='text-sm'>
                                         Account Number :
                                        <strong>{ownerData?.bank_number}</strong>
                                    </Space>
                                </Row>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                {expenseDetails && (
                                    <Row>
                                        <Col span={24} className=' amount-total-two' align='right'>
                                            Total Expense: {formatAmount(billingData.total_expense)}
                                        </Col>
                                    </Row>
                                )}
                                <Row>
                                    <Col span={24} className=' amount-total-two mb-4' align='right'>
                                        Previous Payable: {formatAmount(billingData.previous_payable)}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24} className=' amount-total' align='right'>
                                        Net Income: {formatAmount(billingData.total_net_income)}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        
                        <Row gutter={[16, 16]}>
                            <Col span={24} className='p-2'>
                               <Row className='my-4'>
                                    <Col align='left text-sm'>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            <div>Prepared By,</div>
                                            <img
                                            src={OwnerSignature}
                                            alt="Owner Signature"
                                            style={{ height:'10vh', margin: '0' }}
                                            />
                                            <div style={{ borderTop: '1px solid black', width: '150%', marginTop: '0', marginBottom: '0' }}></div>
                                        </div>
                                        {/* <Space direction='vertical' gutter={[0, 0]}>
                                            Prepared By,
                                            <Image
                                                src={OwnerSignature}
                                                style={{height:'10vh', width: 'auto' }}
                                                preview={false}
                                            />
                                            _________________________
                                        </Space> */}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Row className='text-sm'>LAARNI AMISTOSO GENOVA</Row>
                                        <Row className='text-sm'>Cebu Property Management</Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='btn-footer'>
                    <Space className='mb-4 me-4'>
                        <Button
                            onClick={() => navigate(-1)}
                            className='cancel-color btn-header mb-2'
                        >
                            Cancel
                        </Button>
                    
                        <Button
                             onClick={() => handleSendEmail('preview')}
                             className='secondary-btn mb-2 btn-header'
                             loading={loading}
                        >
                            Send to Email
                        </Button>
                    
                        <Button
                            onClick={handlePrint}
                            type='primary'
                            className='mb-2 btn-header'
                        >
                            Print
                        </Button>
                    </Space>
                </Row>
                <Row>
                    <Col span={24} className='p-4'>
                        Billing Slips
                    </Col>
                </Row>
                <Row className='mx-4'>
                    <Col span={24}>
                        <Table 
                            columns={columns4} 
                            dataSource={expenseDetails} 
                            pagination={false}
                            loading={{
                                indicator: customSpinner,
                                spinning: isLoading,
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className='p-4'>
                        Expense Attachment
                    </Col>
                </Row>
                <Row className='mx-4'>
                    <Col span={24}>
                        <Table 
                            columns={columns3} 
                            dataSource={expenseAttachment} 
                            pagination={false}
                            loading={{
                                indicator: customSpinner,
                                spinning: isLoading,
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className='p-4'>
                        Payment Attachment
                    </Col>
                </Row>
                <Row className='mx-4'>
                    <Col span={24}>
                        <Table 
                            columns={columns3} 
                            dataSource={paymentAttachment} 
                            pagination={false}
                            loading={{
                                indicator: customSpinner,
                                spinning: isLoading,
                            }}
                        />
                    </Col>
                </Row>
                {
                    uniqueIds.map((unique_id, index) => (
                        <Row 
                            key={index} 
                            className='hide-from-screen'
                        >
                            <PreviewBillingSlip
                                id={unique_id}
                                type='owner'
                                setBulkRef={handleBulkPrintRef}
                            />
                        </Row>
                    ))
                }
                <LoadingModal visible={isLoading}/>
            </Layout>
        </Layout>
    )
}

export default PreviewOwnerIncome
